"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
class LoggingBoundary extends react_1.default.Component {
    componentDidCatch(error, errorInfo) {
        this.props.client.error("LoggingBoundary caught unhandled error: ", error, errorInfo);
        // Let parent boundaries handle the error after logging
        if (this.props.rethrow !== false) {
            throw error;
        }
    }
    // Render just passes straight through
    render() {
        return this.props.children;
    }
}
exports.default = LoggingBoundary;
